<div class="address" [mmTestTarget]="'address'">
    <div class="address__actions">
        <app-address-actions-button
                [actionList]="actionList"
                (action)="onActionClick($event)"
                [tooltipLabel]="actionsTooltipLabel">
        </app-address-actions-button>
    </div>

    <div class="address__inner">
        <div class="address__details">
            <app-address-details [address]="address"></app-address-details>
        </div>
        <div class="address__content" >
            <ng-content></ng-content>
        </div>
    </div>
</div>
